module.exports = __webpack_public_path__ + "static/media/017.b7ce265a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/017.jpg
// module id = 364
// module chunks = 0